import { useState, Fragment } from "react";
import Expenses from "./components/Expenses/Expenses";
import { DUMMY_DATA } from "./data";
import "./App.css";
import NewExpense from "./components/New Expenses/NewExpense";

const App = () => {
  const [expenseData, setExpenseData] =
    useState(DUMMY_DATA);

  const [filteredYear, setFilteredYear] =
    useState(2022);
  const changeFilteredYearHandler = (
    filteredYear
  ) => {
    setFilteredYear(filteredYear);
  };
  const filteredExpenseData = expenseData.filter(
    (expense) => {
      return (
        filteredYear.toString() ===
        expense.date.getFullYear().toString()
      );
    }
  );

  const saveExpenseDataHandler = (
    newExpenseData
  ) => {
    // console.log(newExpenseData.enteredDate);
    setExpenseData((prevExpense) => {
      return [...prevExpense, newExpenseData];
    });
  };
  return (
    <Fragment>
      <NewExpense
        onsaveExpenseData={saveExpenseDataHandler}
      />
      <Expenses
        expenseData={filteredExpenseData}
        onChangeFilterYear={
          changeFilteredYearHandler
        }
      />
    </Fragment>
  );
};

export default App;
